import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$lte } from '../../utils/query-helpers';

export const MISSING_FIELDS = {
  // Missing activity
  activityId: {
    $null: true
  },
  // Missing description
  description: {
    $equals: '',
  },
  $or: [
    // Missing date
    {
      $and: [
        {
          specificDate: 'Yes'
        },
        {
          date: {
            $null: true
          }
        }
      ]
    },
    // Missing date range
    {
      $and: [
        {
          specificDate: 'No'
        },
        {
          $or: [
            {
              startDate: {
                $null: true
              }
            },
            {
              endDate: {
                $null: true
              }
            }
          ]
        }
      ]
    },
    // Missing a participant
    {
      ...tags_type_count_$lte(TagTypes.Participant, 0)
    },
    // Missing a method of interaction
    {
      ...tags_type_count_$lte(TagTypes.InteractionType, 0)
    }
  ]
}

export default MISSING_FIELDS;

export const MISSING_FIELDS_ARRAY = Object.keys(MISSING_FIELDS).map(function(key) {
  return {
    [key]: MISSING_FIELDS[key]
  };
});
